export const ATS_PRE_APPLICATIONS_TOUR = 'ats_pre_applications';

export const atsJobActionsWalkthroughSteps = [
  {
    id: 'invited-tab',
    target: '[data-walkthrough="ats-invited-tab"]',
    title: 'Welcome to Your ATS Tour',
    body:
      "Let's walk through the key features of your Applicant Tracking System. We'll start with the Invited tab - this is where you browse our freelancer network and invite experts to apply to your job. Once invited, they'll appear here.",
    placement: 'bottom',
  },
  {
    id: 'applied-tab',
    target: '[data-walkthrough="ats-applied-tab"]',
    title: 'Applied Tab',
    body:
      'When freelancers apply to your job, their applications will appear here. Review their profiles and move them through your hiring pipeline.',
    placement: 'bottom',
  },
  {
    id: 'workflow-tabs',
    target: '[data-walkthrough="ats-workflow-tab"]',
    title: 'Hiring Workflow',
    body:
      'Use the Declined, Reviewed, and Shortlisted tabs to organize your candidates. Move applicants between stages using the action buttons on their profiles or with bulk actions.',
    placement: 'bottom',
    multiTarget: true,
  },
  {
    id: 'hired-tab',
    target: '[data-walkthrough="ats-hired-tab"]',
    title: 'Hired Tab',
    body:
      "This is where your hired experts will stay for this job. You'll return to this tab to manage payments and ongoing work with your hired freelancers.",
    placement: 'bottom',
  },
  {
    id: 'job-actions',
    target: '[data-walkthrough="ats-job-actions"]',
    title: 'Job Management Actions',
    body:
      'Use these cards to manage your job posting. Review public questions, boost your job for more visibility, complete your next steps, and enable AI Recruiter for automated screening.',
    placement: 'bottom',
  },
  {
    id: 'job-menu',
    target: '[data-walkthrough="ats-job-menu"]',
    title: 'Job Settings Menu',
    body:
      'Click the three dots to edit your job details, duplicate this posting, or change visibility settings.',
    placement: 'left',
  },
];
